import { render, staticRenderFns } from "./supplierBlock.vue?vue&type=template&id=576bbb3f&scoped=true"
import script from "./supplierBlock.vue?vue&type=script&lang=js"
export * from "./supplierBlock.vue?vue&type=script&lang=js"
import style0 from "./supplierBlock.vue?vue&type=style&index=0&id=576bbb3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576bbb3f",
  null
  
)

export default component.exports